"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.total-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline; }\n  .total-container .form-total {\n    max-width: 75%; }\n  .total-container .tooltip {\n    color: #a8a8a8;\n    font-size: 12px;\n    font-weight: normal; }\n";
  const fileName = "Total_Total";
  const element = document.querySelector("style[data-sass-component='Total_Total']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Total = _ref => {
  let {
    title,
    value,
    className,
    tooltip
  } = _ref;
  const classNames = ['total-container'];
  if (className) {
    classNames.push(className);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames.join(' ')
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "form-total sia-text-04"
  }, title, tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, tooltip)), /*#__PURE__*/_react.default.createElement("h5", null, value));
};
var _default = exports.default = Total;